import useMediaQuery from '@/hooks/useMediaQuery'

const useIsMobile = () => {
  const isMobile = useMediaQuery('(max-width: 767px)')
  return isMobile
}

export default useIsMobile
